import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    token: null,
  },

  mutations: {
    setUserData(state, userData) {
      state.user = userData;
      localStorage.setItem('user', JSON.stringify(userData));
    },

    clearUserData() {
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      window.location.reload();
    },

    setAuthToken(state, token) {
      state.token = token;
      localStorage.setItem('token', token);
    },
  },

  actions: {
    logout({ commit }) {
      commit('clearUserData');
      window.location.reload();
    },
  },

  getters: {
    isLogged: state => !!state.user,
  },

  modules: {},
});
